import React, { useEffect, useState } from 'react';
import api from '../api';
import styled from 'styled-components';

const ThumbnailContainer = styled.div`
  display: inline-block;
  margin: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 160px;
  transition: transform 0.2s;
  position: relative;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
`;

const ImageContainer = styled.div`
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f9f9f9;
`;

const StyledImage = styled.img`
  max-width: 150px;
  max-height: 140px;
  object-fit: contain;
`;

const ImageName = styled.p`
  font-size: 12px;
  margin: 5px 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ThumbnailViewer = ({ nomeArquivo, idRede, onClick }) => {
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  // Use thumbnail endpoint if possible, otherwise use regular view endpoint
  const apiBase = process.env.REACT_APP_API_BASE_71; 
  const thumbnailApiBase = apiBase;
  
  useEffect(() => {
    let objectUrl;
    
    const fetchImage = async () => {
      setLoading(true);
      
      try {
        // Tentar buscar a thumbnail primeiro
        const response = await api.get(`${thumbnailApiBase}/${nomeArquivo}?id_rede=${idRede}`, {
          responseType: 'blob',
        }).catch(() => {
          // Se falhar, tenta a imagem normal
          return api.get(`${apiBase}/${nomeArquivo}?id_rede=${idRede}`, {
            responseType: 'blob',
          });
        });

        objectUrl = URL.createObjectURL(response.data);
        setImageUrl(objectUrl);
        setError(false);
      } catch (err) {
        console.error('Erro ao carregar thumbnail:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (nomeArquivo && idRede) {
      fetchImage();
    }

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [nomeArquivo, idRede, apiBase, thumbnailApiBase]);

  // Extrai apenas o nome sem a parte técnica
  const displayName = nomeArquivo?.replace(`moldura_${idRede}`, 'Moldura') || 'Moldura';

  return (
    <ThumbnailContainer onClick={() => onClick && onClick(nomeArquivo)}>
      <ImageContainer>
        {loading ? (
          <p>Carregando...</p>
        ) : error ? (
          <p>Não encontrada</p>
        ) : (
          <StyledImage
            src={imageUrl}
            alt={`Thumbnail de ${nomeArquivo}`}
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/150?text=Erro';
              setError(true);
            }}
          />
        )}
      </ImageContainer>
      <ImageName title={nomeArquivo}>{displayName}</ImageName>
    </ThumbnailContainer>
  );
};

export default ThumbnailViewer;